import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../material-module/material.module';
import { SharedModule } from '../../shared.module';

@Component({
  selector: 'app-custom-carousel',
  templateUrl: './custom.carousel.component.html',
  styleUrl: './custom.carousel.component.scss',
  imports: [CommonModule, MaterialModule, SharedModule],
})
export class CustomCarouselComponent implements OnInit {
  loadedImages = new Map<string, boolean>();

  onImageLoad(src: string): void {
    this.loadedImages.set(src, true);
  }

  slides = [
    {
      id: 0,
      src: '/assets/images/landing/kilimanjaro.png',
      title: 'First slide',
      subtitle: 'Nulla vitae elit libero, a pharetra augue mollis interdum.',
    },
    {
      id: 1,
      src: '/assets/images/landing/person-posing.jpeg',
      title: 'Second slide',
      subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    },
    {
      id: 2,
      src: '/assets/images/landing/giraffe.png',
      title: 'Third slide',
      subtitle:
        'Praesent commodo cursus magna, vel scelerisque nisl consectetur.',
    },
    {
      id: 3,
      src: '/assets/images/landing/mountain.jpg',
      title: 'Fourth slide',
      subtitle:
        'Praesent commodo cursus magna, vel scelerisque nisl consectetur.',
    },
    {
      id: 4,
      src: '/assets/images/landing/person_calling.png',
      title: 'Fourth slide',
      subtitle:
        'Praesent commodo cursus magna, vel scelerisque nisl consectetur.',
    },
  ];

  activeIndex = 0;
  previousActiveIndex = this.slides.length - 1;
  direction = signal<'up' | 'down'>('down');

  changeSlide(newIndex: number) {
    this.previousActiveIndex = this.activeIndex;
    this.activeIndex = newIndex;
  }

  isSliding = true;

  onHover(setValue: boolean) {
    this.isSliding = !setValue;
  }

  next(direction: 'up' | 'down' = 'down') {
    let next = (this.activeIndex + 1) % this.slides.length;
    this.changeSlide(next);
    this.direction.set(direction);
  }

  previous(direction: 'up' | 'down' = 'up') {
    if (this.activeIndex != 0) {
      this.changeSlide(this.activeIndex - 1);
    } else {
      this.changeSlide(this.slides.length - 1);
    }
    this.direction.set(direction);
  }

  ngOnInit() {
    setInterval(() => {
      if (this.isSliding) {
        this.next();
      }
    }, 4000);
  }
}
